module.exports = __webpack_public_path__ + "img/105044.9c5b031a.png";